// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#yousign-iframe {\n  width: 100%;\n  border: none;\n  height: 600px;\n}\n", ""]);
// Exports
module.exports = exports;
